<template>
  <el-button class="f-btn" @click="handleClick" :style="{padding:icon==undefined|| icon==''?'5px 16px':'5px 8px'}">
    <svg-icon :icon-class="icon" v-if="icon" :style="{fontSize:iconSize}"></svg-icon>
    <slot/>
  </el-button>
</template>

<script>
    export default {
        name: "index",
        props: {
            icon: {type: String}, iconSize: {
                type: Number, default() {
                    return 16
                }
            }
        },
        methods: {
            handleClick() {
                this.$emit("click")
            }
        }
    }
</script>

<style lang="scss" scoped>
  .f-btn {
  .svg-icon{
    padding-right: 0px;
  }
    margin-right: 0px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #0066FF;
    padding: 5px 16px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #0066FF;
    background: #ffffff;

    position: relative;

    img {
      padding-right: 5px;
      height: 14px;
      position: absolute;
      top: 8px;
      left: 7px;
    }

    i {
      padding-left: 6px;
      font-style: normal;
    }


  }
  // .f-btn:hover {
  //   background-color:   #0066FF;
  //   color: rgba(255, 255, 255, 1);
  // }
  .el-button+.el-button{
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FButton/index.vue